/* eslint-disable no-plusplus */
/* eslint-disable no-prototype-builtins */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export enum BigWheelStatus {
  未开始,
  正在转,
  单轮结果公布,
  开始倒计时,
}

// 接口返回的单个用户信息
interface UserData {
  nickname: string
  mid: number
  avatar: string
  is_self: boolean
}

// 获取大转盘基础数据
export const turntable_get_base_data = createAsyncThunk(
  'turntable_get_base_data',
  async (arg: {room_id?: number} | undefined, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/game/turntable_get_base_data',
      {
        ...deviceinfo, // BaseParam 公共参数
        ...(arg || {}),
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

interface InitialStateType {
  curStatus: BigWheelStatus,
  outMid: number, // 淘汰的mid
  base: {
    room_id: number,
    num: number
    max_num: number
    need_coin: number
    pool_coin: number
    is_can_close: boolean
    user_list: UserData[]
    status: number
    countdown: number
    prepare_timeout: number
    float_broadcast_threshold: number
    room_get_ratio: number
    platform_get_ratio: number
    user_get_ratio: number
    is_prepare_mid: boolean 
  }
  roomReward: {
    get_coin: number, // 房主得到的奖励金币
  }
}
const initialState: InitialStateType = {
  curStatus: BigWheelStatus.未开始,
  outMid: 0,
  base: {
    room_id: 0, // 房间ID
    num: 0, // 当前人数
    max_num: 0, // 最大人数
    need_coin: 0, // 需要金币
    pool_coin: 0, // 奖池金币
    is_can_close: false, // 是否可关闭
    is_prepare_mid: false, // 是否是发起者
    user_list: [], // 初始用户列表
    status: 0, // 初始状态（未开始）
    countdown: 0, // 初始倒计时
    prepare_timeout: 0, // 准备时间（秒）
    float_broadcast_threshold: 0, // 飘屏播报阈值
    room_get_ratio: 0, // 房间分成比例
    platform_get_ratio: 0, // 平台分成比例
    user_get_ratio: 0, // 用户分成比例
  },
  roomReward: {
    get_coin: 0, // 房主得到的奖励金币
  },
}

export const bigWheelSlice = createSlice({
  name: 'bigWheel',
  initialState,
  reducers: {
    updateBase: (state, action: PayloadAction<any>) => {
      // 确保创建新的 base 对象和 user_list 数组引用，以便 React 能检测到变化
      const payload = action.payload || {}
      const newBase: any = {
        ...state.base,
      }
      // 遍历 payload 中的所有字段，确保数组字段创建新引用
      Object.keys(payload).forEach((key) => {
        if (Array.isArray(payload[key])) {
          newBase[key] = [...payload[key]]
        } else if (payload[key] !== undefined) {
          newBase[key] = payload[key]
        }
      })
      state.base = newBase
      // 如果 payload 中有 out_mid，也更新 state.outMid
      if (payload.out_mid !== undefined) {
        state.outMid = payload.out_mid
      }
    },
    updateRoomReward: (state, action: PayloadAction<any>) => {
      const {roomReward} = state
      Object.assign(state, {
        roomReward: {
          ...roomReward,
          ...action.payload,
        },
      })
    },
    updateCurStatus: (state, action: PayloadAction<BigWheelStatus>) => {
      state.curStatus = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      turntable_get_base_data.fulfilled,
      (state, action: PayloadAction<any>) => {
        if (action.payload) {
          // 使用 updateBase 来更新，确保数组字段创建新引用
          const newBase: any = {
            ...state.base,
            ...action.payload,
          }
          // 遍历 payload 中的所有字段，确保数组字段创建新引用
          Object.keys(action.payload).forEach((key) => {
            if (Array.isArray(action.payload[key])) {
              newBase[key] = [...action.payload[key]]
            }
          })
          state.base = newBase
          // 如果 payload 中有 out_mid，也更新 state.outMid
          if (action.payload.out_mid !== undefined) {
            state.outMid = action.payload.out_mid
          }
          state.curStatus = action.payload.status as BigWheelStatus
        }
      }
    )
  },
})
export default bigWheelSlice.reducer
export const bigWheelActions = bigWheelSlice.actions
